import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    display: 'block',
    marginBottom: '8px'
  },
  item: {
    width: '100%',
    height: '61px',
    boxSizing: 'border-box',
    border: '1px solid #E5E5E5',
    borderRadius: '8px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    textAlign: 'center',
    color: '#454545',
    background: 'transparent',
    cursor: 'pointer'
  },
  selected: {
    border: 'none',
    fontWeight: 700,
    color: '#ffffff',
    background: theme.colors.primary,
  }
}))


function Item (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })

  const onSelect = () => {
    if (props.onSelect) {
      props.onSelect()
    }
  }

  const itemStyles = props.selected ? 
    `${styles.item} ${styles.selected}` : styles.item

  return (
    <View className={styles.root}>
      <button 
        className={itemStyles} 
        onClick={onSelect}
      >
        {props.label}
      </button>
    </View>
  )
}

export default Item